import React from 'react';
import typeTranslations from '../../../../assets/creator/typeTranslations';
import { getTranslation } from '../../../../assets/creator/translations';
import jsondata from '../../../../assets/elements.json';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const faChevronDown = (<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="m12.002 15.948 5.656-5.666a.752.752 0 0 0 0-1.062.75.75 0 0 0-1.06 0L12 13.928 7.405 9.22a.75.75 0 0 0-1.06 0 .752.752 0 0 0 0 1.062l5.657 5.666z" fill="#767676" />
</svg>
)
const faChevronUp = (<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="m12.002 8.55 5.656 5.666a.752.752 0 0 1 0 1.062.75.75 0 0 1-1.06 0L12 10.57l-4.595 4.708a.75.75 0 0 1-1.06 0 .752.752 0 0 1 0-1.062l5.657-5.666z" fill="#767676" />
</svg>
)

export const DropdownIcon = ({ isSelected }) => {
    if (isSelected) {
        return faChevronUp;
    }
    return faChevronDown;
};

const isTypeMissing = (missingTypes, type, bodyListName) => (
    missingTypes.includes(type) && (
        jsondata.globalTypes.indexOf(type) !== -1 || //check for global type missing
        jsondata.requiredTypes[bodyListName].indexOf(type) !== -1 || // check if type from page body is missing
        // check case when requirement is defined as set of types and we need to put at least one type from that set
        jsondata.requiredTypes[bodyListName].findIndex(val => (Array.isArray(val) && val.indexOf(type) !== -1)) !== -1 
    )
)

const WarningIcon = ({ isCheckEnabled, missingTypes, type, bodyListName }) => {
    if (isCheckEnabled && isTypeMissing(missingTypes, type, bodyListName)) {
        return (
            <svg className="element-type__warning" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z" />
            </svg>
        );
    }
    return null;
};


const TypeDropdownControl = ({ type, isSelected, isCheckEnabled, missingTypes, onClick, bodyListName, isHighlighted }) => {
    return (
        <div className="element-type__control" onClick={onClick}>
            <div className="element-type__name">
                {getTranslation(typeTranslations[type])}
                <WarningIcon
                    isCheckEnabled={isCheckEnabled}
                    missingTypes={missingTypes}
                    type={type}
                    bodyListName={bodyListName}
                />
            </div>

            {isHighlighted && (
                <div className="highlightedLabel">{getTranslation("Rec_NewProduct")}</div>
            )}

            <DropdownIcon isSelected={isSelected} />
        </div>
    );
};

export default TypeDropdownControl;